import * as React from 'react';
import ModalContainer from 'src/modules/commons/modal-handler/Modal.container';

interface ModalHandlerComponentProps {
    modalContent?: JSX.Element;
    className?: string;
}

const ModalHandlerComponent = (props: ModalHandlerComponentProps) => {
    return (
        <ModalContainer {...props} /> 
    );
};

export default ModalHandlerComponent;


// WEBPACK FOOTER //
// ./src/modules/commons/modal-handler/ModalHandler.component.tsx